import React, { type ReactNode } from 'react'

import { Typography } from '../../typography/Typography'
import { variantForStyleId } from '../../typography/variants'
import { weekdaylabelContract } from './weekdaylabel.contract'

export const WEEKDAY_LABEL_TEXT = variantForStyleId(weekdaylabelContract.textStyleIds[0])

export type WeekdayLabelProps = {
    children: ReactNode
    className?: string
    testID?: string
}

/**
 * One column heading in a calendar: Mo, Tu, We.
 *
 * The smallest component in the package — a text style and `content/default`,
 * and Figma declares no property at all. It is here rather than inlined because
 * `CalendarSheet` instantiates it seven times, and a heading whose ink lived in
 * the grid would drift the first time either changed.
 */
export const WeekdayLabel = ({ children, className, testID }: WeekdayLabelProps) => (
    <Typography
        variant={WEEKDAY_LABEL_TEXT}
        className={className}
        testID={testID ?? 'weekday-label'}
    >
        {children}
    </Typography>
)

WeekdayLabel.displayName = 'WeekdayLabel'
